/**
 * In-memory access/refresh token holder (UI-SPEC interaction contract).
 *
 * Tokens live ONLY in module memory — never localStorage/sessionStorage — so a
 * stolen-storage / XSS-persistence vector cannot lift them (threat T-20-09).
 * `apiFetch` reads the access token to set `Authorization: Bearer`; the auth
 * client writes both after login/refresh and clears them on logout / refresh
 * failure. The HttpOnly refresh cookie set by the api host is the durable
 * credential; the refresh token string here mirrors the P12 bearer contract
 * used by the refresh endpoint body.
 */

let accessToken: string | null = null;
let refreshToken: string | null = null;
// Access-token lifetime (seconds) as reported by login/refresh. Held in module
// memory only (never storage, threat T-20-09) so the proactive refresh
// scheduler can time itself ~60s before expiry.
let accessTokenExpiresIn: number | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return refreshToken;
}

export function getAccessTokenExpiresIn(): number | null {
  return accessTokenExpiresIn;
}

export function setTokens(next: {
  accessToken: string;
  refreshToken?: string | null;
  accessTokenExpiresIn?: number | null;
}): void {
  accessToken = next.accessToken;
  if (next.refreshToken !== undefined) {
    refreshToken = next.refreshToken;
  }
  if (next.accessTokenExpiresIn !== undefined) {
    accessTokenExpiresIn = next.accessTokenExpiresIn;
  }
}

export function clearTokens(): void {
  accessToken = null;
  refreshToken = null;
  accessTokenExpiresIn = null;
}
